import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/servizi/Servizi.vue'),
		meta: {
			title: 'servizi',
			acl: 'section.servizi'
		}
	},
	{
		path: 'new',
		component: () => import('@/views/servizi/servizio/ServizioDetail.vue'),
		meta: {
			title: 'new-servizio',
			acl: 'section.serviziperiodici'
		}
	},
	{
		path: ':servizioid/edit',
		component: () => import('@/views/servizi/servizio/ServizioDetail.vue'),
		props: true,
		meta: {
			title: 'edit-servizio',
			acl: 'section.servizi'
		}
	},
];

export default routes;